export type PracticePackCheckoutResponse = {
  clientSecret?: unknown;
  url?: unknown;
};

export type PracticePackCheckoutStart =
  | { kind: "embedded"; clientSecret: string }
  | { kind: "hosted"; url: string }
  | { kind: "invalid" };

export function resolvePracticePackCheckout(
  response: PracticePackCheckoutResponse,
): PracticePackCheckoutStart {
  const clientSecret =
    typeof response.clientSecret === "string"
      ? response.clientSecret.trim()
      : "";
  if (clientSecret.startsWith("cs_")) {
    return { kind: "embedded", clientSecret };
  }

  const url = typeof response.url === "string" ? response.url : "";
  if (isStripeCheckoutUrl(url)) {
    return { kind: "hosted", url };
  }

  return { kind: "invalid" };
}

function isStripeCheckoutUrl(raw: string): boolean {
  try {
    const url = new URL(raw);
    return (
      url.protocol === "https:" &&
      url.hostname === "checkout.stripe.com" &&
      url.pathname.startsWith("/c/pay/")
    );
  } catch {
    return false;
  }
}
